/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */

import BaseFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/BaseFormElement";

export default class BaseAdditionalFormElement extends BaseFormElement {

	constructor(type, title, isRequired) {
		super(type, title, isRequired);
	}

	resetElement(){
		super.resetElement()
		this.showCopy = false
	}
}
